import {useContext} from 'react'
import useApi from '../../../../services/useApi'
import {ProjectDetailsContext} from '../../context'

const useGetProjectModules = () => {
  const Api = useApi()
  const {projectId} = useContext(ProjectDetailsContext)
  const {data: response, isFetching} = Api.useGetQuery(`/agile/projects/${projectId}/modules`)

  return {
    projectModules: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetProjectModules
